<template>
    <section id="features" class="section features-area overflow-hidden ptb_100">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-12 col-md-10 col-lg-6">
                        <!-- Section Heading -->
                        <div class="section-heading text-center">
                            <h2>We let Content Creators be themselves.</h2>
                            <p class="d-sm-block mt-4">
                                Bypass censorship, demonitization and schedules by connecting your audience directly to advertizers through a common thread; you.
                            </p>
                            <p class="d-sm-block mt-4">
                                We automatically establish relationships and get you paid so you can focus on what you got into making content for in the first place.
                            </p>
                        </div>
                    </div>
                </div>
                <div class="row align-items-center">
                    <div class="col-12 col-md-6 col-lg-4">
                        <!-- Features Item -->
                        <ul class="features-item">
                            <div class="row justify-content-center">
                                <h2>Audience</h2>
                                <img src="assets/img/audience.png" alt="">
                            </div>
                            <li>
                                <!-- Image Box -->
                                <div class="image-box media px-1 py-3 py-md-4 wow fadeInLeft" data-aos-duration="2s" data-wow-delay="0.3s">
                                    <!-- Featured Image -->
                                    <div class="featured-img mr-3">
                                        <img class="avatar-sm" src="assets/img/featured_image_1.png" alt="">
                                    </div>
                                    <!-- Icon Text -->
                                    <div class="icon-text media-body align-self-center align-self-md-start">
                                        <h3 class="mb-2">No More Ads</h3>
                                        <p>Say goodbye to commercial breaks, pre-roll ads and in-video sponsorships. Creators that use SourceSync now have a non-invasive way to monetize their content.</p>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <!-- Image Box -->
                                <div class="image-box media px-1 py-3 py-md-4 wow fadeInLeft" data-aos-duration="2s" data-wow-delay="0.6s">
                                    <!-- Featured Image -->
                                    <div class="featured-img mr-3">
                                        <img class="avatar-sm" src="assets/img/featured_image_2.png" alt="">
                                    </div>
                                    <!-- Icon Text -->
                                    <div class="icon-text media-body align-self-center align-self-md-start">
                                        <h3 class="mb-2">Support What You Love</h3>
                                        <p>Fund your favorite content simply by engaging with it! Every time you interact with monetized smart content, the creator you're watching gets paid.</p>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <!-- Image Box -->
                                <div class="image-box media px-1 py-3 py-md-4 wow fadeInLeft" data-aos-duration="2s" data-wow-delay="0.9s">
                                    <!-- Featured Image -->
                                    <div class="featured-img mr-3">
                                        <img class="avatar-sm" src="assets/img/featured_image_3.png" alt="">
                                    </div>
                                    <!-- Icon Text -->
                                    <div class="icon-text media-body align-self-center align-self-md-start">
                                        <h3 class="mb-2">Enhanced Experience</h3>
                                        <p>Get AI-powered smart content recommendations for things relevant to what you're actually interested in; all within your control and without being tracked accross the web.</p>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="col-12 col-lg-4 d-none d-lg-block">
                        <!-- Featutes Thumb -->
                        <div class="features-thumb text-center">
                            <img src="assets/img/sourcesync-mobile.png" alt="">
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-4">
                        <div class="row justify-content-center">
                            <h2>Advertizers</h2>
                            <img src="assets/img/brands.png" alt="" class="">
                        </div>
                        <!-- Features Item -->
                        <ul class="features-item">
                            <li>
                                <!-- Image Box -->
                                <div class="image-box media px-1 py-3 py-md-4 wow fadeInRight" data-aos-duration="2s" data-wow-delay="0.9s">
                                    <!-- Featured Image -->
                                    <div class="featured-img mr-3">
                                        <img class="avatar-sm" src="assets/img/featured_image_6.png" alt="">
                                    </div>
                                    <!-- Icon Text -->
                                    <div class="icon-text media-body align-self-center align-self-md-start">
                                        <h3 class="mb-2">Stop Annoying People</h3>
                                        <p>Take the guesswork out of campaigning by targeting behavior instead of demographics. People in need of your services will engage more often and appreciate you.
                                        </p>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <!-- Image Box -->
                                <div class="image-box media px-1 py-3 py-md-4 wow fadeInRight" data-aos-duration="2s" data-wow-delay="0.3s">
                                    <!-- Featured Image -->
                                    <div class="featured-img mr-3">
                                        <img class="avatar-sm" src="assets/img/featured_image_4.png" alt="">
                                    </div>
                                    <!-- Icon Text -->
                                    <div class="icon-text media-body align-self-center align-self-md-start">
                                        <h3 class="mb-2">Risk-Free Sponsorship</h3>
                                        <p>Don't endorse a person, endorse their audience. If a Content Creator violates company policy, just auction your sponsorship NFT and everybody wins.</p>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <!-- Image Box -->
                                <div class="image-box media px-1 py-3 py-md-4 wow fadeInRight" data-aos-duration="2s" data-wow-delay="0.6s">
                                    <!-- Featured Image -->
                                    <div class="featured-img mr-3">
                                        <img class="avatar-sm" src="assets/img/featured_image_5.png" alt="">
                                    </div>
                                    <!-- Icon Text -->
                                    <div class="icon-text media-body align-self-center align-self-md-start">
                                        <h3 class="mb-2">Happier Customers</h3>
                                        <p>Appear exactly when people want you to, offering the exact thing they need, every time. Appeal to every person that can benefit from your product without any research.</p>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
</template>

<script>
export default {
    
}
</script>

<style>

</style>